import { render } from "./ProvideOriginalPageListWidget.vue?vue&type=template&id=4c91751e&ts=true"
import script from "./ProvideOriginalPageListWidget.ts?vue&type=script&lang=ts&external"
export * from "./ProvideOriginalPageListWidget.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__